import axios from "axios";
import { BASEURL } from "baseUrl";
import { toast } from "react-toastify";

export const ADD_PURCHASE_BILL = 'ADD_PURCHASE_BILL';
export const VERIFY_OTP = 'VERIFY_OTP';
export const CAL_PURCHASE_BILL = 'CAL_PURCHASE_BILL';
export const GET_PURCHASE_BILL = 'GET_PURCHASE_BILL';
export const DELETE_PURCHASE_BILL = 'DELETE_PURCHASE_BILL';
export const VIEW_PURCHASE_BILL = 'VIEW_PURCHASE_BILL';
export const PURCHASE_PURCHASE_BILL = 'PURCHASE_PURCHASE_BILL';
export const ADD_SALE_BILL = 'ADD_SALE_BILL';
export const GET_SALE_BILL = 'GET_SALE_BILL';
export const DELETE_SALE_BILL = 'DELETE_SALE_BILL';
export const VIEW_SALE_BILL = 'VIEW_SALE_BILL';
export const UPDATE_SALE_BILL = 'UPDATE_SALE_BILL';
export const ADD_PURCHASE_RETURN = 'ADD_PURCHASE_RETURN';
export const GET_PURCHASE_RETURN = 'GET_PURCHASE_RETURN';
export const UPDATE_PURCHASE_RETURN = 'UPDATE_PURCHASE_RETURN';
export const DELETE_PURCHASE_RETURN = 'DELETE_PURCHASE_RETURN';
export const VIEW_PURCHASE_RETURN = 'VIEW_PURCHASE_RETURN';

const addPurchaseBillAction = (payload) => ({ type: ADD_PURCHASE_BILL, payload: payload });
const verifyOtpAction = (payload) => ({ type: VERIFY_OTP, payload: payload });
const calPurchaseBillAction = (payload) => ({ type: CAL_PURCHASE_BILL, payload: payload });
const getPurchaseBillAction = (payload) => ({ type: GET_PURCHASE_BILL, payload: payload });
const deletePurchaseBillAction = (payload) => ({ type: DELETE_PURCHASE_BILL, payload: payload });
const viewPurchaseBillAction = (payload) => ({ type: VIEW_PURCHASE_BILL, payload: payload });
const updatePurchaseBillAction = (payload) => ({ type: PURCHASE_PURCHASE_BILL, payload: payload });
const addSaleBillAction = (payload) => ({ type: ADD_SALE_BILL, payload: payload });
const getSaleBillAction = (payload) => ({ type: GET_SALE_BILL, payload: payload });
const deleteSaleBillAction = (payload) => ({ type: DELETE_SALE_BILL, payload: payload });
const viewSaleBillAction = (payload) => ({ type: VIEW_SALE_BILL, payload: payload });
const updateSaleBillAction = (payload) => ({ type: UPDATE_SALE_BILL, payload: payload });
const addPurchaseReturnBillAction = (payload) => ({ type: ADD_PURCHASE_RETURN, payload: payload });
const getPurchaseReturnBillAction = (payload) => ({ type: GET_PURCHASE_RETURN, payload: payload });
const updatePurchaseReturnBillAction = (payload) => ({ type: UPDATE_PURCHASE_RETURN, payload: payload });
const deletePurchaseReturnBillAction = (payload) => ({ type: DELETE_PURCHASE_RETURN, payload: payload });
const viewPurchaseReturnBillAction = (payload) => ({ type: VIEW_PURCHASE_RETURN, payload: payload });

export const addPurchaseBill = (payload, limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/billing/registerPurchaseBill`, payload).then(((res) => {
                toast.success('Add Purchase Bill successfully')
                dispatch(addPurchaseBillAction(res));
                dispatch(getPurchaseBill(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addPurchaseBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)

            console.log('Error login user:', error);
        }
    }
}

export const verifyOtp = (payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/verifyOtp`, payload).then(((res) => {
                toast.success('Add Purchase Bill successfully')
                dispatch(verifyOtpAction(res));
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(verifyOtpAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)

            console.log('Error login user:', error);
        }
    }
}

export const calPurchaseBill = (payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/billing/calculatePurchaseBill`, payload).then(((res) => {
                dispatch(calPurchaseBillAction(res));
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(calPurchaseBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)

            console.log('Error login user:', error);
        }
    }
}

export const getPurchaseBill = (limits) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/billing/getAllPurchaseBills?page=${limits.page}&limit=${limits.limit}&search=${limits.search}`).then(((res) => {
                dispatch(getPurchaseBillAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getPurchaseBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)

            console.log('Error login user:', error);
        }
    }
}

export const deletePurchaseBill = (id, limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/billing/deletePurchaseBill/${id}`).then(((res) => {
                toast.success('Delete Purchase Bill successfully')
                dispatch(deletePurchaseBillAction(res));
                dispatch(getPurchaseBill(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deletePurchaseBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const viewPurchaseBill = (id) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/billing/viewPurchaseBill/${id}`).then(((res) => {
                dispatch(viewPurchaseBillAction(res));
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(viewPurchaseBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const updatePurchaseBill = (payload, limits, ids) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/billing/updatePurchaseBill/${ids}`, payload).then(((res) => {
                toast.success('Update Purchase Bill Successfully!')
                dispatch(updatePurchaseBillAction(res));
                dispatch(getPurchaseBill(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updatePurchaseBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const addSaleBill = (payload, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token');
            await axios.post(`${BASEURL}/billing/registerSalesBill`, payload,{
                headers:{
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }).then(((res) => {
                toast.success('Add Sale Bill successfully')
                console.log('res----', res);
                dispatch(addSaleBillAction(res));
                dispatch(getSaleBill(limits))
                localStorage.setItem('salesId', res?.data?.billId)
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addSaleBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getSaleBill = (limits) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');
        try {
            await axios.get(`${BASEURL}/billing/getAllSalesBills?page=${limits.page}&limit=${limits.limit}&search=${limits.search}`,{
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }).then(((res) => {
                dispatch(getSaleBillAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getSaleBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)

            console.log('Error login user:', error);
        }
    }
}

export const deleteSaleBill = (id, limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/billing/deleteSalesBill/${id}`).then(((res) => {
                toast.success('Delete Sale Bill Successfully!')
                dispatch(deleteSaleBillAction(res));
                dispatch(getSaleBill(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteSaleBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)

            console.log('Error login user:', error);
        }
    }
}

export const viewSaleBill = (id) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/billing/viewSalesBill/${id}`).then(((res) => {
                dispatch(viewSaleBillAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(viewSaleBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const updateSaleBill = (payload, limits, ids) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token');

            await axios.put(`${BASEURL}/billing/updateSalesBill/${ids}`, payload,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                        }
                }
            ).then(((res) => {
                toast.success('Update Sale Bill Successfully!')
                dispatch(updateSaleBillAction(res));
                dispatch(getSaleBill(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateSaleBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const addPurchaseReturn = (payload, limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/billing/registerPurchseReturnBill`, payload).then(((res) => {
                toast.success('Add Purchase Return Successfully!')
                dispatch(addPurchaseReturnBillAction(res));
                dispatch(getPurchaseReturnBill(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addPurchaseReturnBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)

            console.log('Error login user:', error);
        }
    }
}

export const getPurchaseReturnBill = (limits) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/billing/getAllPurchaseReturnBills?page=${limits.page}&limit=${limits.limit}&search=${limits.search}`).then(((res) => {
                dispatch(getPurchaseReturnBillAction(res));
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(getPurchaseReturnBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)

            console.log('Error login user:', error);
        }
    }
}

export const updatePurchaseReturnBill = (payload, limits, ids) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/billing/updatePurchaseReturnBill/${ids}`, payload).then(((res) => {
                toast.success('Update Purchase Return Successfully!')
                dispatch(updatePurchaseReturnBillAction(res));
                dispatch(getPurchaseReturnBill(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updatePurchaseReturnBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const deletePurchaseReturnBill = (id, limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/billing/deletePurchaseReturnBill/${id}`).then(((res) => {
                toast.success('Delete Purchase Return successfully')
                dispatch(deletePurchaseReturnBillAction(res));
                dispatch(getPurchaseReturnBill(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deletePurchaseReturnBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const viewPurchaseReturnBill = (id) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/billing/viewPurchaseReturnBill/${id}`).then(((res) => {
                dispatch(viewPurchaseReturnBillAction(res));
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(viewPurchaseReturnBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}